export default "__VITE_ASSET__Bo_0Woi1__"